import {api} from "../config";

export default {
  data () {
    return {
    }
  },
  mounted() {

  },
  methods: {
    statusSection(status) {
      let self = this;
      axios.post(api.updateStatusSection, {
        section_id: self.$store.getters.section_data.section_id,
        status: status,
      })
      .then((resp) => {
        console.log(`updateStatusSection: ${status}`);
        self.$store.dispatch("setSectionStatus", status);
      });
    },
    statusLesson(status) {
      let self = this;
      axios.post(api.updateStatusLesson, {
        lesson_id: self.$store.getters.lesson_data.lesson_id,
        status: status
      })
      .then((resp) => {
        console.log(`updateStatusLesson: ${status}`)
        self.$store.dispatch('setLessonStatus', status)
      })
    },
    statusNextLesson(lessonData, status) {
      let self = this;
      axios.post(api.updateStatusLesson, {
        lesson_id: lessonData.lesson_id,
        status: status
        })
    },
    statusContent(status, step, data) {
      let self = this;

      let params =  {
        section_id: self.$store.getters.section_data.section_id,
        lesson_id: self.$store.getters.lesson_data.lesson_id,
        content_id: self.$store.getters.lesson_content[step].content_id,
        status: status,
      };

      if(data !== undefined && 'content_data_type' in data && 'content_data_order' in data) {
        params['content_data_type'] = data.content_data_type;
        params['content_data_order'] = data.content_data_order;
      }

      axios.post(api.updateStatusContent, params)
      .then((resp) => {
        console.log(`updateStatusContent: ${status}`)
        self.$store.dispatch('setContentStatus', status)
      })
    },
  }
}
